<template>
	<AmeliproBtn
		:aria-current="isActive ? 'page' : undefined"
		classes="amelipro-pagination__btn"
		:color="isActive ? 'ap-blue darken-1' : 'ap-white'"
		hover-color="ap-blue darken-1"
		:href="href"
		:text-color="isActive ? 'ap-white' : 'ap-blue darken-1'"
		text-hover-color="ap-white"
		:title="isActive ? 'page active' : title"
		:to="to"
		@click="emitClickEvent()"
	>
		<template #default>
			<slot />
		</template>

		<template #icon>
			<slot name="icon" />
		</template>
	</AmeliproBtn>
</template>

<script setup lang="ts">
	import AmeliproBtn from '../AmeliproBtn';
	import { PropType } from 'vue/types/v3-component-props';
	import { RawLocation } from 'vue-router';

	defineProps({
		href: {
			type: String,
			default: undefined,
		},
		isActive: {
			type: Boolean,
			default: false,
		},
		title: {
			type: String,
			default: undefined,
		},
		to: {
			type: [Array, Object, String] as PropType<RawLocation>,
			default: undefined,
		},
	});
	const emit = defineEmits(['click']);

	const emitClickEvent = (): void => {
		emit('click');
	};
</script>

<style lang="scss" scoped>
.v-btn {
	padding: 0 !important;
	border-radius: 0 !important;
	min-height: 2.5rem !important;
	min-width: 2.5rem !important;
	font-size: $font-size-sm !important;
	font-weight: $ap-font-weight-semi-bold !important;
	text-align: center !important;
	& :deep(.v-btn__content) {
		padding-left: 0 !important;
		padding-right: 0 !important;
	}

	& :deep(.v-badge) span {
		margin-left: 0 !important;
	}
}
</style>
